import {
  RecorderState,
  useRecorderState,
} from 'core/api-middleware/demo-middleware/recorder';

import { BaseFeatureState } from '@cast/infrastructure-abilities';

// Extend recorder state with getOverridesCount for dev-toolbox integration
type OpTourRecorderState = RecorderState & BaseFeatureState;

type StateSelector<T> = (state: OpTourRecorderState) => T;

const extendState = (state: RecorderState): OpTourRecorderState => ({
  ...state,
  getIsActive: () => state.isActive,
});

export const useOpTourRecorderState = Object.assign(
  <T>(selector?: StateSelector<T>): T => {
    return useRecorderState((state: RecorderState) => {
      const extended = extendState(state);
      return selector ? selector(extended) : (extended as unknown as T);
    });
  },
  {
    getState: (): OpTourRecorderState =>
      extendState(useRecorderState.getState()),
  }
);
